/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Next_BillingInputs */

const en_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next billing date: ${i?.date}`)
};

const de_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nächstes Abrechnungsdatum: ${i?.date}`)
};

const fr_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prochaine date de facturation : ${i?.date}`)
};

const es_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próxima fecha de facturación: ${i?.date}`)
};

const it_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prossima data di fatturazione: ${i?.date}`)
};

const nl_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Volgende factuurdatum: ${i?.date}`)
};

const pl_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Następna data rozliczenia: ${i?.date}`)
};

const fi_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seuraava laskutuspäivä: ${i?.date}`)
};

const da_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Næste faktureringsdato: ${i?.date}`)
};

const sv_settings_next_billing = /** @type {(inputs: Settings_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nästa faktureringsdatum: ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Next billing date: {date}" |
*
* @param {Settings_Next_BillingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_next_billing = /** @type {((inputs: Settings_Next_BillingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Next_BillingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_next_billing(inputs)
	if (locale === "fr") return fr_settings_next_billing(inputs)
	if (locale === "es") return es_settings_next_billing(inputs)
	if (locale === "it") return it_settings_next_billing(inputs)
	if (locale === "nl") return nl_settings_next_billing(inputs)
	if (locale === "pl") return pl_settings_next_billing(inputs)
	if (locale === "fi") return fi_settings_next_billing(inputs)
	if (locale === "da") return da_settings_next_billing(inputs)
	if (locale === "sv") return sv_settings_next_billing(inputs)
	return en_settings_next_billing(inputs)
});